import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {assignChipNumbersValidator, getLanguageValue, required} from "@utility";
import {AbstractComponent} from "../abstract.component";
import {EventItem, Race, AssignChipNumbersRequest} from "@model";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'assign-chip-numbers-modal',
  templateUrl: './assign-chip-numbers-modal.component.html',
  styleUrls: ['./assign-chip-numbers-modal.component.scss']
})
export class AssignChipNumbersModalComponent extends AbstractComponent implements OnInit {
  @Input() event: EventItem | undefined;
  @Input() race: Race | undefined;
  @Input() title: string | undefined;
  @Input() confirmButtonTitle: string | undefined;
  @Input() dismissButtonTitle: string | undefined;

  racesList: Map<number, string> = new Map<number, string>();

  inputForm = new FormGroup({
    races: new FormControl(),
    chipNumbers: new FormControl(),
    replaceExisting: new FormControl(),
  });

  constructor(public activeModal: NgbActiveModal,
              public translocoService: TranslocoService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.racesList = this.getOptions();
    this.initForm();
  }

  getOptions(): Map<number, string> {
    const optionsMap: Map<number, string> = new Map<number, string>();
    if (this.race?.id) {
      optionsMap.set(this.race.id,
          getLanguageValue(this.race?.name,
              this.race?.nameEng, this.race?.nameIta,
              this.race?.nameSlo, this.race?.nameSr,
              this.race?.nameBs, this.translocoService.getActiveLang()) ?? "");
    }
    else {
      this.event?.racesList?.map((race: Race) => {
        if (race.id) {
          optionsMap.set(race.id,
              getLanguageValue(race.name,
                  race.nameEng, race.nameIta,
                  race.nameSlo, race.nameSr,
                  race.nameBs, this.translocoService.getActiveLang()) ?? "");
        }
      });
    }
    return optionsMap;
  }

  private initForm() {
    this.inputForm.controls.chipNumbers.addValidators([required, assignChipNumbersValidator]);
    this.inputForm.controls.races.addValidators([required]);
    this.inputForm.updateValueAndValidity();
    this.inputForm.controls.races.setValue(this.race ? [this.race.id] : this.event?.racesList?.map(r => r.id))
  }

  onConfirmClick(): void {
    const request: AssignChipNumbersRequest = new AssignChipNumbersRequest(
        this.inputForm.controls.races.value,
        this.inputForm.controls.chipNumbers.value,
        this.inputForm.controls.replaceExisting.value
        )
    this.activeModal.close(request);
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }
}
